import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase-config';

const HOMEPAGE_FEATURE_STORAGE_KEY = 'homepageFeatureSettings';

const getCachedHomepageFeature = () => {
    try {
        const storedSettings = localStorage.getItem(HOMEPAGE_FEATURE_STORAGE_KEY);

        if (!storedSettings) {
            return null;
        }

        return JSON.parse(storedSettings);
    } catch (error) {
        return null;
    }
};

const normalizeHomepageFeature = (settings) => {
    if (!settings) {
        return null;
    }

    return {
        ...settings,
        featured_image: settings.featured_image || null
    };
};

const getInitialHomepageFeature = () => normalizeHomepageFeature(getCachedHomepageFeature());

const useHomepageFeature = () => {
    const [homepageFeature, setHomepageFeature] = useState(getInitialHomepageFeature);
    const [homepageFeatureLoading, setHomepageFeatureLoading] = useState(() => !getInitialHomepageFeature());

    useEffect(() => {
        const loadHomepageFeature = async () => {
            try {
                const featureSettings = await getDoc(doc(db, 'site_settings', 'homepage_feature'));
                const resolvedSettings = !featureSettings.exists()
                    ? null
                    : normalizeHomepageFeature(featureSettings.data());

                setHomepageFeature(resolvedSettings);

                if (resolvedSettings) {
                    localStorage.setItem(HOMEPAGE_FEATURE_STORAGE_KEY, JSON.stringify(resolvedSettings));
                } else {
                    localStorage.removeItem(HOMEPAGE_FEATURE_STORAGE_KEY);
                }
            } catch (err) {
                console.error('Failed to load homepage feature settings:', err);
                setHomepageFeature(getInitialHomepageFeature());
            } finally {
                setHomepageFeatureLoading(false);
            }
        };

        loadHomepageFeature();
    }, []);

    return {
        homepageFeature,
        homepageFeatureLoading
    };
};

export default useHomepageFeature;
